module.exports = __webpack_public_path__ + "static/img/ent-93.3a9c8d7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-93.jpg
// module id = 20v1
// module chunks = 52